export default class PlayerSizeConstants {
    static readonly handSize = 400; // длина руки игрока, т.е. смещение старта броска биты относительно центра игрока (в мм)
}